import React from 'react';

function EmbedIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-566 -1345)">
          <g transform="translate(531 1175)">
            <path d="M48.125 170c-1.875 0-3.625.75-5.25 2.375-1.5 1.625-2.25 3.25-2.375 5.125 0 1.875.625 3.5 2.125 5 .375.375.75.625 1.125.875.875-1.125 1.25-2.5 1-4.125l.25.25.5.75c.5.875.625 1.75.5 2.5-.125.875-.625 1.75-1.375 2.375-1 .875-1.875 1.375-2.875 1.375-.875 0-1.625-.375-2.375-1-.625-.625-1-1.375-1-2.125s.125-1.5.75-2.25c-.5-1.375-.75-2.75-.625-4.125-.5.375-.75.625-1.125.875C35.875 179.5 35 181.125 35 183s.625 3.5 2.125 5c1.375 1.25 2.875 2 4.75 2 .75 0 1.5-.125 2.125-.375.75-.25 1.375-.625 2.125-1.125 1.125-.875 2-1.875 2.625-3 .25-.375.375-.75.375-.875.5-1.25.5-2.5.25-3.75s-1-2.375-1.875-3.375c-.875-.875-1.75-1.375-2.875-1.75.125-.25.375-.625.75-1 1-.875 1.875-1.375 2.875-1.375.875 0 1.625.375 2.375 1 .75.75 1 1.5 1 2.375 0 .625-.25 1.375-.75 2.125.5 1.125.75 2.25.75 3.375v.75c.375-.25.75-.5 1-.875C54.25 180.5 55 178.75 55 176.875c0-1.75-.75-3.375-2.125-4.75S50 170 48.125 170z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default EmbedIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/EmbedIcon.js